var _path, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSettingsInstagram(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5996 3.7998C19.0333 3.7998 20.2002 4.96658 20.2002 6.40039V17.5996C20.2002 19.0333 19.0334 20.2002 17.5996 20.2002H6.40039C4.96668 20.2002 3.7998 19.0334 3.7998 17.5996V6.40039C3.7998 4.96668 4.96658 3.7998 6.40039 3.7998H17.5996ZM6.40039 4.7334C5.48142 4.7334 4.7334 5.4815 4.7334 6.40039V17.6006C4.73359 18.5194 5.48162 19.2666 6.40039 19.2666H17.5996C18.5185 19.2666 19.2664 18.5193 19.2666 17.6006V6.40039C19.2666 5.48142 18.5185 4.7334 17.5996 4.7334H6.40039ZM17.0664 6.2002C17.4709 6.2002 17.7998 6.52913 17.7998 6.93359C17.7996 7.33792 17.4708 7.66699 17.0664 7.66699C16.6622 7.66682 16.3332 7.33781 16.333 6.93359C16.333 6.52923 16.6621 6.20037 17.0664 6.2002Z",
    fill: "#909090",
    stroke: "#909090",
    strokeWidth: 0.4
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 3.85,
    stroke: "#909090",
    strokeWidth: 1.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingsInstagram);
export default __webpack_public_path__ + "static/media/settings_instagram.f33338fff9fe97dfd8bb8f21f00a6dc3.svg";
export { ForwardRef as ReactComponent };